export const KNOWN_VARS = [
  "first_name",
  "last_name",
  "phone_number",
  "agency_name",
  "business_name",
];

export const GetVariablesToShow = (variables: string[]) => {
  return variables.filter((v) => !KNOWN_VARS.includes(v)).sort();
};

/**
 * One name per case-insensitive spelling.
 *
 * Winner is the lexicographically smallest spelling (`<`), not API/DB order —
 * `variable_fields` is not guaranteed to return a stable order, so "first seen"
 * would make Try Agent and VariableEditor disagree across loads (GAIL-1110).
 * Group order in the result follows first encounter of that case-fold key.
 *
 * ContactModal / contact detail intentionally do not use this — a record can
 * still hold distinct values under each spelling.
 */
export const DedupeVariablesByCase = (names: string[]): string[] => {
  const bestByLower = new Map<string, string>();
  const order: string[] = [];

  for (const name of names) {
    const lower = name.toLowerCase();
    const existing = bestByLower.get(lower);
    if (existing === undefined) {
      bestByLower.set(lower, name);
      order.push(lower);
      continue;
    }
    if (name < existing) {
      bestByLower.set(lower, name);
    }
  }

  return order.map((lower) => bestByLower.get(lower)!);
};
